module.exports = __webpack_public_path__ + "img/search.72ef2f1a.svg";